import React from "react";
import { FaCheck, FaUserFriends } from "react-icons/fa";

import {
  DEFAULT_AVATAR,
  getAdherentName,
  getAdherentSubtitle,
} from "../utils/preparationPhysiqueAdherentUtils";

function AdherentPrepaSelector({ adherents, selectedId, onSelect }) {
  if (!adherents?.length) return null;

  return (
    <div className="mb-6 rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200">
          <FaUserFriends />
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
            Judoka sélectionné
          </p>

          <p className="font-titre text-xl font-bold text-slate-950 dark:text-white">
            Choisir le profil sportif
          </p>
        </div>
      </div>

      <div className="mt-4 flex gap-3 overflow-x-auto pb-1">
        {adherents.map((adherent) => {
          const isActive = adherent.id === selectedId;

          return (
            <button
              key={adherent.id}
              type="button"
              onClick={() => onSelect(adherent.id)}
              className={`flex min-w-[220px] items-center gap-3 rounded-[1.4rem] border p-3 text-left transition ${
                isActive
                  ? "border-emerald-300 bg-emerald-50 shadow-lg shadow-emerald-500/10 dark:border-emerald-400/30 dark:bg-emerald-500/10"
                  : "border-slate-200 bg-slate-50 hover:bg-white hover:shadow-md dark:border-white/10 dark:bg-white/[0.04] dark:hover:bg-white/[0.08]"
              }`}
            >
              <img
                src={adherent.photo_url || DEFAULT_AVATAR}
                alt={getAdherentName(adherent)}
                className="h-12 w-12 rounded-2xl object-cover"
                onError={(event) => {
                  event.currentTarget.src = DEFAULT_AVATAR;
                }}
              />

              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-bold text-slate-950 dark:text-white">
                  {getAdherentName(adherent)}
                </p>

                <p className="truncate text-xs font-semibold text-slate-500 dark:text-white/50">
                  {getAdherentSubtitle(adherent)}
                </p>
              </div>

              {isActive && <FaCheck className="shrink-0 text-emerald-500" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default AdherentPrepaSelector;